module.exports = __webpack_public_path__ + "img/weixin-user.2ae3499a.png";